import { notifications } from '@mantine/notifications';
import {
  getCruiseKey,
  getCruisesKey,
  useGetCruise,
  useUpdateCruise,
} from 'api-hooks/cruise';
import { NavigationRoutes } from 'common/constants';
import { NavigatorParams } from 'common/constants/navigator-params';
import { PreviousNavigation } from 'common/helpers/previous-navigation';
import { queryClient } from 'common/repositories/query-client';
import { useRouter } from 'next/router';

import CruiseForm from './components/form';

export default function CruiseView() {
  const { query, back } = useRouter();
  const id = query?.id as string;
  const queryView = useGetCruise(
    {
      id,
    },
    { enabled: !!id },
  );
  const updateMutation = useUpdateCruise();

  return (
    <CruiseForm
      query={queryView}
      saveMutation={updateMutation}
      onSubmit={async (input) => {
        const result = await updateMutation.mutateAsync({
          body: input,
          cruiseId: id,
        });

        notifications.show({ message: result.message, color: 'green' });

        const prevPath = PreviousNavigation.get();
        if (prevPath) {
          PreviousNavigation.remove();
          NavigatorParams.remove(NavigationRoutes.CruisesView);
          back();
          return result.data;
        }

        queryClient.refetchQueries([getCruisesKey()[0]]);
        queryClient.refetchQueries(getCruiseKey({ id: result.data.id }));

        return result.data;
      }}
    />
  );
}
